module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/store_images/1@2x_d5c407f4361487bbe3c08f6becc5f154.png";